export enum NoteReference {
  PARTNER = 'PARTNER', // eslint-disable-line
  BENEFICIARY = 'BENEFICIARY', // eslint-disable-line
  INVESTOR = 'INVESTOR', // eslint-disable-line
}

export type Note = {
  _id?: string;
  date: string | Date;
  text: string;
  reference: string;
  referenceId: string;
  externalId: string;
  userId: string;
  society: string;
};
